import { client } from "api";
import { Company } from "models/Company";

export type ArchiveCompanyRequest = {
  companyId: string;
  reason: string;
};

export type ArchiveCompanyResponse = Company;

export const archiveCompany = ({ companyId, reason }: ArchiveCompanyRequest) =>
  client.post<ArchiveCompanyResponse>(`/company/${companyId}/archive`, { reason }).then((res) => res.data);
